import { IonFab, IonIcon, IonButton } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setCreateStep } from "../../../store/massiveDocumentCreate";
import { chevronBackCircleOutline } from "ionicons/icons";
import { selectSelectedUsers } from "../../../store/massiveDocumentCreate/selectors/selectSelectedUsers";
import { findSelectedUsers } from "../../../store/massiveDocumentCreate/actions/findSelectedUsers";
import { UserTablePreview } from "./UserTablePreview";

export const PreviewInformationTable = () => {
  const dispatch = useDispatch();
  const selectedUsers = useSelector(selectSelectedUsers);

  const codeOfUsersToGet = selectedUsers.map((user) => user.code);

  useEffect(() => {
    dispatch(findSelectedUsers(codeOfUsersToGet));
  }, []);

  return (
    <>
      <UserTablePreview title="Preview Datos Plantilla" />
      <IonFab vertical="bottom" horizontal="end" slot="fixed">
        <IonButton color="secondary" onClick={() => dispatch(setCreateStep(2))}>
          <IonIcon icon={chevronBackCircleOutline} slot="start"></IonIcon>
          <span>Volver</span>
        </IonButton>
      </IonFab>
    </>
  );
};
